import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ContentComponent} from "./content.component";
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [ContentComponent],
  exports: [ContentComponent]

})
export class ContentModule { }



// WEBPACK FOOTER //
// ./src/app/pages/content/content.module.ts